// https://tracker.globetrack.ie/issues/11520 - pure helpers for the AI Setup
// Usage tab, kept out of the component so they can be exercised on their own.

const pad = (n) => (n < 10 ? `0${n}` : `${n}`);

// Local calendar date -> "YYYY-MM-DD".
export const isoDate = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// { from, to } for the calendar month containing `now`, offset by `delta`
// months (-1 = last month). Matches the backend default for delta 0.
export const monthRange = (now, delta = 0) => {
  const first = new Date(now.getFullYear(), now.getMonth() + delta, 1);
  const last = new Date(now.getFullYear(), now.getMonth() + delta + 1, 0);
  return { from: isoDate(first), to: isoDate(last) };
};

// Every "YYYY-MM-DD" from `from` to `to` inclusive. UTC arithmetic so DST
// changes never skip or repeat a day.
export const daysBetween = (from, to) => {
  const out = [];
  if (!from || !to) return out;
  const start = Date.parse(`${from}T00:00:00Z`);
  const end = Date.parse(`${to}T00:00:00Z`);
  if (isNaN(start) || isNaN(end) || start > end) return out;
  for (let t = start; t <= end; t += 86400000) {
    out.push(new Date(t).toISOString().slice(0, 10));
  }
  return out;
};

// The backend omits days without calls; give every day of the range a row.
export const fillDays = (from, to, rows) => {
  const byKey = {};
  (rows || []).forEach((r) => (byKey[r.key] = r));
  return daysBetween(from, to).map((day) => ({
    day,
    calls: byKey[day] ? byKey[day].calls : 0,
    costUsd: byKey[day] ? byKey[day].costUsd : 0,
  }));
};

// USD: 4 decimals for non-zero amounts under $1 so fractions of a cent stay
// visible, else 2 (zero is "$0.00").
export const formatCost = (v) => {
  const n = Number(v) || 0;
  const digits = n !== 0 && Math.abs(n) < 1 ? 4 : 2;
  return `$${n.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;
};

export const formatInt = (v) => (Number(v) || 0).toLocaleString("en-US");

// errors / calls, as a percentage string; capped calls are not errors.
export const errorRate = (errors, calls) => {
  if (!calls) return "0%";
  const pct = (100 * (errors || 0)) / calls;
  return `${pct < 10 && pct > 0 ? pct.toFixed(1) : Math.round(pct)}%`;
};

export const formatDuration = (ms) => {
  if (ms === null || ms === undefined) return "";
  return ms < 1000 ? `${ms} ms` : `${(ms / 1000).toFixed(1)} s`;
};

export const eventStatus = (e) => {
  if (e.capped) return "capped";
  return e.ok ? "ok" : "error";
};

export const sourceLabel = (e) => {
  if (!e.sourceType) return "";
  return e.sourceId != null ? `${e.sourceType} #${e.sourceId}` : e.sourceType;
};

// "Dec 3" style label for a "YYYY-MM-DD" chart category.
const MONTHS = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" ");
export const shortDay = (day) => {
  const [, m, d] = day.split("-").map(Number);
  return `${MONTHS[m - 1]} ${d}`;
};



// WEBPACK FOOTER //
// ./src/components/gt/admin/ai-setup/ai-usage-helpers.js